import { firebaseApp } from "../firebase"
import { getDatabase, ref, get, child, update } from "firebase/database";

const state = {
  produtos: [],
  precos: [],
  precosCm2: [],
  imagens: [],
  sem_img: "",
  version: "",
};

const getters = {
  produtos(state) {
    return state.produtos;
  },
  precos(state) {
    return state.precos;
  },
  precosCm2(state) {
    return state.precosCm2;
  },
  imagens(state) {
    return state.imagens;
  },
  sem_img(state) {
    return state.sem_img;
  },
  version(state) {
    return state.version;
  },
};

const actions = {
  loadVersion({ commit }) {
    let manifest = document.querySelector('link[rel="manifest"]');
    let file = manifest.href;
    let v = "";
    fetch(file)
      .then((response) => response.json())
      .then((data) => {
        v = data;
        commit("setVersion", v.version);
      });
  },
  loadImagens({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "imagens/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const imgs = [];
          const obj = snapshot.val();
          for (const key in obj) {
            imgs.push({
              id: key,
              nome: obj[key].nome,
              url: obj[key].url,
            });
          }
          commit("setImagens", imgs);
        } else {
          console.log("Dados não encontrados.");
          commit("setImagens", []);
        }
      })
      .catch((error) => {
        console.error(error);
        commit("setImagens", []);
      });
  },
  setImagens({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["imagens/"] = obj;
    update(ref(db), updates);
    dispatch("loadImagens");
  },
  loadProdutos({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "produtos/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const produtos = snapshot.val();
          commit("setProdutos", produtos);
        } else {
          console.log("Dados não encontrados.");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  loadPrecos({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "precos/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const precos = snapshot.val();
          commit("setPrecos", precos);
        } else {
          console.log("Dados não encontrados.");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  loadPrecosCm2({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "precosCm2/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const precos = snapshot.val();
          commit("setPrecosCm2", precos);
        } else {
          console.log("Dados não encontrados.");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  setPrecosSlim({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["precos/slim/"] = obj;
    update(ref(db), updates);
    dispatch("loadPrecos");
  },
  setPrecosAcessorios({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["precos/acessorios/"] = obj;
    update(ref(db), updates);
    dispatch("loadPrecos");
  },
  setPrecosPremium({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["precos/premium/"] = obj;
    update(ref(db), updates);
    dispatch("loadPrecos");
  },
  setPrecosCm2({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["precosCm2/"] = obj;
    update(ref(db), updates);
    dispatch("loadPrecosCm2");
  },
};

const mutations = {
  setProdutos(state, obj) {
    state.produtos = obj;
  },
  setImagens(state, obj) {
    state.imagens = obj;
    state.sem_img = obj[19].url;
  },
  setPrecos(state, obj) {
    state.precos = obj;
  },
  setPrecosCm2(state, obj) {
    state.precosCm2 = obj;
  },
  setVersion(state, n) {
    state.version = "v - " + n;
  },
};

export default {
    state,
    getters,
    actions,
    mutations
}
